import React from 'react';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const CsrPolicy = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Corporate Social Responsibility (CSR) Policy</h1>
            <p className="last-updated">Digital Fig Ltd<br/>Effective Date: 28 March 2026<br/>Review Cycle: Annually</p>

            <h2>1. Purpose</h2>
            <p>Digital Fig Ltd is committed to delivering measurable social value through accessible digital services, ethical business practices, and support for community-driven organisations. Our CSR strategy focuses on reducing barriers to digital participation and enabling sustainable economic growth.</p>

            <h2>2. Key Commitments</h2>
            <h3>2.1 Economic Accessibility and Inclusion</h3>
            <p>We actively reduce financial barriers for businesses and organisations by:</p>
            <ul>
              <li>Offering affordable, fixed-cost website solutions</li>
              <li>Subsidising platform fees for Charities and CIC sector.</li>
              <li>Supporting early-stage businesses with cost-effective digital entry points</li>
            </ul>
            <p>This approach enables wider participation in the digital economy, particularly for underserved or resource-constrained groups.</p>

            <h3>2.2 Community Impact and Social Value</h3>
            <p>We prioritise working with organisations that deliver social benefit, including:</p>
            <ul>
              <li>Charities</li>
              <li>Community Interest Companies (CICs)</li>
              <li>Social enterprises</li>
            </ul>
            <p>Our support includes:</p>
            <ul>
              <li>Subsidised website development and digital services</li>
              <li>Flexible pricing structures aligned to organisational capacity</li>
              <li>Ongoing guidance to maximise digital effectiveness</li>
            </ul>

            <h3>2.3 Ethical and Transparent Operations</h3>
            <p>We maintain high standards of integrity by:</p>
            <ul>
              <li>Providing transparent, upfront pricing</li>
              <li>Avoiding hidden fees or restrictive contracts</li>
              <li>Ensuring honest communication and clear deliverables</li>
            </ul>

            <h3>2.4 Digital Accessibility</h3>
            <p>We are committed to inclusive design principles by:</p>
            <ul>
              <li>Delivering user-friendly, accessible websites</li>
              <li>Supporting clients with limited technical knowledge</li>
              <li>Promoting best practices in usability and accessibility</li>
            </ul>

            <h3>2.5 Innovation for Public Benefit</h3>
            <p>Digital Fig develops and supports SaaS platforms and digital tools designed to:</p>
            <ul>
              <li>Improve access to services</li>
              <li>Deliver practical value to businesses and individuals</li>
              <li>Address real-world challenges through scalable technology</li>
            </ul>

            <h2>3. Measurable Intent</h2>
            <p>To strengthen accountability, Digital Fig aims to:</p>
            <ul>
              <li>Continue providing subsidised or discounted services to eligible organisations</li>
              <li>Increase the number of socially impactful organisations supported annually</li>
              <li>Expand access to digital tools through scalable SaaS solutions</li>
            </ul>

            <h2>4. Review and Accountability</h2>
            <p>This policy is reviewed annually to ensure alignment with business growth, stakeholder needs, and evolving best practices in social responsibility.</p>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default CsrPolicy;
